import { animateTo, setTabContentTo } from '../../shared/helpers';

export default class extends Controller {

  navigateToStarredItem(event) {
    event && event.preventDefault();
    const tab = document.querySelector(`[data-tab-id=${this.tabID}]`);
    const target = document.querySelector('.tab-pane');
    setTabContentTo({ tab, target, url: this.url, pushState: true }).then(() => animateTo(document.querySelector(this.starrableID), 500));
  }

  //
  // GETTERS AND SETTINGS
  //

  get tabID() {
    return this.data.get('tab-id');
  }

  get url() {
    return this.data.get('url');
  }

  get starrableID() {
    return this.data.get('starrable-id');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/stars/star-card-controller.js